import { Routes } from '@angular/router';
import { Shell } from './core/layout/shell';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  {
    path: 'connexion',
    title: 'Connexion · iMatch',
    loadComponent: () =>
      import('./features/auth/pages/login-page').then((m) => m.LoginPage),
  },
  {
    path: 'unauthorized',
    title: 'Accès non autorisé · iMatch',
    loadComponent: () =>
      import('./features/auth/pages/unauthorized-page').then(
        (m) => m.UnauthorizedPage,
      ),
  },
  {
    path: 'mot-de-passe-oublie',
    title: 'Mot de passe oublié · iMatch',
    loadComponent: () =>
      import('./features/auth/pages/company-forgot-password-page').then(
        (m) => m.CompanyForgotPasswordPage,
      ),
  },
  {
    path: 'reinitialiser-mot-de-passe',
    title: 'Réinitialiser le mot de passe · iMatch',
    loadComponent: () =>
      import('./features/auth/pages/company-reset-password-page').then(
        (m) => m.CompanyResetPasswordPage,
      ),
  },
  // Alias conservés : des emails déjà envoyés pointent sur ces URLs.
  {
    path: 'entreprise/mot-de-passe-oublie',
    title: 'Mot de passe oublié · iMatch',
    loadComponent: () =>
      import('./features/auth/pages/company-forgot-password-page').then(
        (m) => m.CompanyForgotPasswordPage,
      ),
  },
  {
    path: 'entreprise/reinitialiser-mot-de-passe',
    title: 'Réinitialiser le mot de passe · iMatch',
    loadComponent: () =>
      import('./features/auth/pages/company-reset-password-page').then(
        (m) => m.CompanyResetPasswordPage,
      ),
  },
  {
    path: 'entretien/repondre/:token',
    title: 'Réponse entretien · iMatch',
    loadComponent: () =>
      import('./features/entretiens/pages/entretien-reponse-page').then(
        (m) => m.EntretienReponsePage,
      ),
  },
  {
    path: 'matching/repondre/:token',
    title: 'Réponse proposition · iMatch',
    loadComponent: () =>
      import('./features/matching/pages/matching-reponse-page').then(
        (m) => m.MatchingReponsePage,
      ),
  },
  {
    path: 'cvtheque/profiles/:invitationId',
    title: 'Espace Apprenants · iMatch',
    loadComponent: () =>
      import('./features/public-profiles/pages/public-profiles-page').then(
        (m) => m.PublicProfilesPage,
      ),
  },
  {
    path: 'offres-publiques/:id',
    title: 'Offres · iMatch',
    loadComponent: () =>
      import('./features/offres-partagees/pages/offres-partagees-page').then(
        (m) => m.OffresPartageesPage,
      ),
  },
  {
    path: 'offres-partagees/:token',
    title: 'Mes offres partagées · iMatch',
    loadComponent: () =>
      import('./features/offres-partagees/pages/offres-partagees-page').then(
        (m) => m.OffresPartageesPage,
      ),
  },
  {
    path: 'offres-partagees',
    title: 'Mes offres partagées · iMatch',
    loadComponent: () =>
      import('./features/offres-partagees/pages/offres-partagees-page').then(
        (m) => m.OffresPartageesPage,
      ),
  },
  {
    path: '',
    component: Shell,
    canActivate: [authGuard, roleGuard],
    data: { roles: ['user', 'admin'] },
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.routes'),
      },
      {
        path: 'cvtheque',
        loadChildren: () => import('./features/cvtheque/cvtheque.routes'),
      },
      {
        path: 'offres',
        loadChildren: () => import('./features/offres/offres.routes'),
      },
      {
        path: 'entreprises',
        loadChildren: () => import('./features/entreprises/entreprises.routes'),
      },
      {
        path: 'matching',
        loadChildren: () => import('./features/matching/matching.routes'),
      },
      {
        path: 'entretiens',
        loadChildren: () => import('./features/entretiens/entretiens.routes'),
      },
      {
        path: 'profile',
        title: 'Profil · iMatch',
        loadComponent: () =>
          import('./features/profile/pages/profile-page').then(
            (m) => m.ProfilePage,
          ),
      },
      {
        path: 'notifications',
        title: 'Notifications · iMatch',
        loadComponent: () =>
          import('./features/notifications/pages/notifications-page').then(
            (m) => m.NotificationsPage,
          ),
      },
      {
        path: 'support',
        title: 'Support · iMatch',
        loadComponent: () =>
          import('./features/support/pages/support-page').then(
            (m) => m.SupportPage,
          ),
      },
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
    ],
  },
  { path: '**', redirectTo: '' },
];
